import {
    useCallback,
} from "preact/compat";

import {
    ADMIN_TAB_SHORTCUTS,
} from "../shortcuts/definitions.ts";

import {
    useKeyboardHandler,
} from "./useKeyboardHandler.ts";

type ManageShortcutHandlers = {
    onTabSwitch?: (tabId: string) => void;
    onShowHelp?: () => void;
    onEscape?: () => void;
};

export const useManageKeyboardShortcuts = (
    handlers: ManageShortcutHandlers,
): void => {
    const onKeyDown = useCallback(
        (event: KeyboardEvent) => {
            const tabId = ADMIN_TAB_SHORTCUTS[event.key];
            if (tabId && handlers.onTabSwitch) {
                event.preventDefault();
                handlers.onTabSwitch(tabId);
            }
        },
        [handlers],
    );

    useKeyboardHandler({
        onKeyDown,
        onEscape: handlers.onEscape,
        onShowHelp: handlers.onShowHelp,
    });
};
